export const providers = {
  CUSTOM: 1,
  GMAIL: 2,
  OFFICE: 3,
}

export const MAILBOXES_SET = 'MAILBOXES_SET'
export const MAILBOXES_DELETE_SUCCESS = 'MAILBOXES_DELETE_SUCCESS'
